/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: sitemap
 * Page name: sitemap page
 * Page Description: This is the sitemap page of the website of Ekathva Innovations.
 */

import React, { useEffect } from 'react'
import { Row, Col } from "react-bootstrap"
import { Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import Navbar from "components/Navbars/Navbar"
import Footer from "components/Footers/Footer"
import LandingPageSite from "components/Headers/LandingPageSite"

function Sitemap() {

  useEffect( () => {
      window.scrollTo(0, 0)
  }, [])


    return (
    <div>
        <MetaTags>
            <title>Sitemap | Ekathva Innovations Pvt Ltd</title>
        </MetaTags>

        <Navbar/>
        <LandingPageSite/>

        <br/>
        <div className='aboutus_mainspace' >
            <Row>
                <Col>
                <Link to="/index">
                    <p className="sitemap_mainfontcolor" ><strong>Home</strong></p>
                </Link>
                <Link to="/about-us">
                    <p className="sitemap_mainfontcolor" ><strong>About Us</strong></p>
                </Link>
                <Link to="/products">
                    <p className="sitemap_mainfontcolor" ><strong>Products</strong></p>
                </Link>
                <Link to="/success-story">
                    <p className="sitemap_mainfontcolor" ><strong>Success Stories</strong></p>
                </Link>
                <Link to="/contact-us">
                    <p className="sitemap_mainfontcolor" ><strong>Contact Us</strong></p>
                </Link>
                <Link to="/training">
                    <p className="sitemap_mainfontcolor" ><strong>Training</strong></p>
                </Link>
                <Link to="/media-gallery">
                    <p className="sitemap_mainfontcolor" ><strong>Media</strong></p>
                </Link>
                <Link to="/privacy-policy">
                    <p className="sitemap_mainfontcolor" ><strong>Privacy Policy</strong></p>
                </Link>
                </Col>
                <Col>
                <p className="sitemap_mainservice" > <strong> Services</strong> </p>
                <Link to="/embedded-services">
                    <p className="sitemap_mainservicefont " ><strong>Embedded Services</strong></p>
                </Link>
                <hr/>
                <Link to="/it-services">
                    <p className=" sitemap_mainservicefont" ><strong>IT services</strong></p>
                </Link>
                <hr/>
                <Link to="/technologies">
                    <p className="sitemap_mainservicefont " ><strong>Technologies</strong></p>
                </Link>
                <hr/>
                <Link to="/career">
                    <p className="sitemap_mainservicefont " ><strong>Career</strong></p>
                </Link>
                <hr/>
                <Link to="/testimonials">
                    <p className="sitemap_mainservicefont " ><strong>Testimonials</strong></p>
                </Link>
                <hr/>
                <Link to="/our-clients">
                    <p className=" sitemap_mainservicefont" ><strong>Our Clients</strong></p>
                </Link>
                </Col>
                <Col>
                <p className="sitemap_mainservice" > <strong> Connect with us</strong> </p>
                <a href="https://www.facebook.com/EkathvaInnovationsPvtLtd/" target="_blank">
                    <p className="sitemap_mainservicefont " ><strong>Facebook</strong></p>
                </a>
                <hr/>
                <a href="https://www.linkedin.com/company/ekathva-innovations" target="_blank">
                    <p className="sitemap_mainservicefont " ><strong>LinkedIn</strong></p>
                </a>
                <hr/>
                <a href="https://www.instagram.com/ekathva_innovations/" target="_blank">
                    <p className=" sitemap_mainservicefont" ><strong>Instagram</strong></p>
                </a>
                <hr/>
                <a href="https://api.whatsapp.com/send?phone=919663805228" target="_blank">
                    <p className="sitemap_mainservicefont " ><strong>WhatsApp</strong></p>
                </a>
                </Col>
            </Row>
        </div>
        <Footer/>

        </div>
    )
}

export default Sitemap
